export enum FILE_TYPES {
    Playbook = 0,
    Manual = 1,
    Legal = 2,
    Accounts = 3,
}
